import React from 'react'
import TemplateAnalytics from '../../company-profile/customerAccountDetails/SideNavigationPages/TemplateAnalytics/TemplateAnalytics'

function TemplateAnalyticsAdmin() {
  return (
    <>
      <TemplateAnalytics />
    </>
  )
}

export default TemplateAnalyticsAdmin